<div class="header-bar">
  <h1>Preset Rate Cards <i *ngIf="isBusy" class="fa fa-spin fa-spinner"></i></h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <div class="grid filterPanel" *ngIf="isPricingAdmin">
        <div class="col-12">
          <form [formGroup]="form" (ngSubmit)="createPreset()">
            <div class="grid">
              <div class="col-12"><h2 class="sub-header-bar mb-0">Create Rate Card Preset</h2></div>
            </div>
            <!-- Flex container for inline layout -->
            <div class="d-flex align-items-center" style="grid-gap: 20px">
              <!-- Input field container -->
              <div class="flex-grow-1">
                <input
                  class="input-field"
                  formControlName="presetName"
                  placeholder="Preset Name"
                  aria-label="Preset Name"
                  maxlength="32"
                />
              </div>
              <!-- Button container -->
              <div>
                <button
                  pButton
                  type="submit"
                  class="ui-button alternate-btn"
                  aria-label="Create Rate Card Preset"
                >
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="grid">
        <div class="col-12">
          <p-table
            selectionMode="single"
            [value]="presets"
            [responsive]="true"
            rowHover="true"
            resizableColumns="true"
            [(selection)]="selectedPreset"
            (selectionChange)="loadSelectedPreset()"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>InactiveDate</th>
                <th>Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr [pSelectableRow]="item">
                <td>{{ item.id }}</td>
                <td>{{ item.presetName }}</td>
                <td>{{ item.inactiveDate | datex : 'ddd DD MMM HH:mm' }}</td>
                <td>
                  <button
                    *ngIf="!item.inactiveDate"
                    type="button"
                    pButton
                    (click)="activationChange(item)"
                    icon="fa ui-icon-lock-open"
                    pTooltip="Deactivate Preset"
                    [disabled]="!isPricingAdmin"
                  ></button>
                  <button
                    *ngIf="item.inactiveDate"
                    type="button"
                    pButton
                    (click)="activationChange(item)"
                    icon="fa ui-icon-lock"
                    pTooltip="Reactivate Preset"
                    [disabled]="!isPricingAdmin"
                  ></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div
        class="ui-grid-row"
        *ngIf="selectedPreset?.servicePricings?.length > 0 && selectedRateCardData"
      >
        <div class="ui-g-12">
          <h2 class="sub-header-bar">Services Provided</h2>

          <p-accordion [multiple]="true" [class.rate-card-accordion]="true">
            <p-accordionTab header="Driven" [selected]="true">
              <p-tabView>
                <p-tabPanel header="Standard Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[0][0]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[0][0])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
                <p-tabPanel header="Urgency Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[0][2]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[0][2])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>

                <p-tabPanel header="Standard Postcode Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[0][3]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[0][3])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
                <p-tabPanel header="Urgency Postcode Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[0][5]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[0][5])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
              </p-tabView>
            </p-accordionTab>

            <p-accordionTab header="Transported">
              <p-tabView>
                <p-tabPanel header="Standard Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[1][0]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[1][0])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
                <p-tabPanel header="Urgency Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[1][2]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[1][2])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>

                <p-tabPanel header="Standard Postcode Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[1][3]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[1][3])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
                <p-tabPanel header="Urgency Postcode Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[1][5]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[1][5])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
              </p-tabView>
            </p-accordionTab>
            <p-accordionTab header="Recovery">
              <p-tabView>
                <p-tabPanel header="Standard Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[2][0]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[2][0])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
                <p-tabPanel header="Out of Hours Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[2][1]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[2][1])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>

                <p-tabPanel header="Standard Postcode Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[2][3]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[2][3])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
                <p-tabPanel header="Out of Hours Postcode Pricing">
                  <rate-card-grid
                    [datas]="selectedRateCardData[2][4]"
                    [useBanding]="false"
                    [agreementBandings]="null"
                    [pricesReadonly]="!isPricingAdmin"
                    (cellValueChanged)="rateCardDataChanged($event, selectedRateCardData[2][4])"
                    [inclusivityTypes]="inclusivityTypes"
                  >
                  </rate-card-grid>
                </p-tabPanel>
              </p-tabView>
            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
